export default __webpack_public_path__ + "c78277d126dc5c646608fbf90ce3f1ba.png";